import apiClient from './client';

export const zonesApi = {
  getAll(params = {}) {
    return apiClient.get('/zones', params);
  },

  getById(id) {
    return apiClient.get(`/zones/${id}`);
  },

  create(data) {
    return apiClient.post('/zones', data);
  },

  update(id, data) {
    return apiClient.put(`/zones/${id}`, data);
  },

  delete(id) {
    return apiClient.delete(`/zones/${id}`);
  },

  getCode(id) {
    return apiClient.get(`/zones/${id}/code`);
  },
};

export default zonesApi;
